import React, { useEffect } from 'react';
import { Box, Button } from '@sparknz/spark-pattern-library';
import { LinkRegion, trackDigitalEvent } from '@sparknz/tracking';

const TRACKING_EVENT_ACTION = 'actionLayer.view';

interface AddRelatedOfferStepProps {
  isAddingBundles: boolean;
  description: React.ReactNode;
  title: React.ReactNode;
  regionId: string;
  eventName: string;
  onNext(): void;
  onSkip(): void;
}

const trackActionLayerViewEvent = (eventName: string) => {
  const event = {
    event: TRACKING_EVENT_ACTION,
    w3cddl: {
      event: [
        {
          eventInfo: {
            eventName: eventName,
            eventAction: TRACKING_EVENT_ACTION,
          },
        },
      ],
    },
  };

  trackDigitalEvent(event);
};

const AddRelatedOfferStep = ({
  isAddingBundles,
  description,
  eventName,
  regionId,
  title,
  onNext,
  onSkip,
}: AddRelatedOfferStepProps) => {
  useEffect(() => {
    trackActionLayerViewEvent(eventName);
  }, [eventName]);

  return (
    <LinkRegion regionId={regionId}>
      <Box mb="s3">{title}</Box>
      {description}
      <Box flexDirection="column" gap="s2">
        <Button
          variant="primary"
          onClick={onNext}
          disabled={isAddingBundles}
          fullWidth
        >
          See details
        </Button>
        <Button
          variant="default"
          onClick={onSkip}
          isLoading={isAddingBundles}
          fullWidth
        >
          No thanks, continue
        </Button>
      </Box>
    </LinkRegion>
  );
};

export default AddRelatedOfferStep;
